export default __webpack_public_path__ + "ecd02403b4c1350932b21e1076866188.png";